import { render, staticRenderFns } from "./ScoringPreview.vue?vue&type=template&id=b688b048&"
import script from "./ScoringPreview.vue?vue&type=script&lang=js&"
export * from "./ScoringPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports